export default __webpack_public_path__ + "static/media/startGameBg.386dee1a.png";